import { EventEmitter, ElementRef } from '@angular/core';
import { CommonService } from '../../app/common.service';
import { ActivatedRoute } from '@angular/router';
var ComponentApproach = (function () {
    function ComponentApproach(el, commonService, route) {
        this.el = el;
        this.commonService = commonService;
        this.route = route;
        this.onGoCourse = new EventEmitter();
        this.assetsRoute = "../../assets";
        this.buttonTheme = {
            'position': 'inherit',
            'fontSize': 'fontSize15',
            'buttonElem': [
                {
                    'color': 'blue',
                    'text': '',
                    'className': 'inlineBlockRadiusBtn width-100 margin-auto'
                }
            ]
        }; //按钮主题
        this.isShowBtn = false; //是否隐藏按钮
    }
    ComponentApproach.prototype.ngOnInit = function () {
        var _this = this;
        this.assetsRoute = this.commonService.setAssetsRoute(this.assetsRoute);
        this.label = this.theme.label;
        this.buttonTheme.buttonElem[0].text = this.theme.btnTxt;
        this.route.queryParams.subscribe(function (queryParams) {
            _this.type = queryParams['type'];
        });
        if (this.type) {
            this.theme.desc = '请点击左侧边栏中能力考核进行学习 ~';
        }
        this.isShowBtn = localStorage.getItem("source_env") == "LMS_SCORM" && localStorage.getItem("moduleId") && Number(localStorage.getItem("moduleId")) == 4 ? true : false;
    };
    ComponentApproach.prototype.ngAfterViewInit = function () {
        if (this.isShowBtn) {
            document.getElementById("approachModule").removeAttribute("style");
            document.getElementById("approachModuleWrap").style.height = "auto";
        }
    };
    return ComponentApproach;
}());
export { ComponentApproach };



// WEBPACK FOOTER //
// ./src/component-ui/approach/component.approach.ts.pre-build-optimizer.js